/**
 * "Support session" wording, shared by the top toolbar's icon button
 * (CobrowseButton) and the status strip's text button (BottomToolbar), so the
 * one action reads the same in both places. The icon is SupportSessionIcon.
 */

/**
 * The visible label, which is also the accessible name in both places.
 *
 * While a session runs, the button brings the support chat back rather than
 * ending the session. It used to end it: a customer who had shrunk the chat
 * and reached for this button to get it back — most often the icon, whose
 * label is only a tooltip — lost their session in one click. Ending is in the
 * chat, which asks first.
 */
export function supportSessionLabel(
  status: string,
  sessionCode: string | null | undefined,
  /** Only for a button that also minimises the chat (the status strip's). */
  chatOpen = false,
): string {
  const code = sessionCode ? ` (${sessionCode})` : '';
  if (status === 'active') return chatOpen ? `Minimize Support Chat${code}` : `Show Support Chat${code}`;
  if (status === 'connecting' || status === 'requesting-consent') return 'Starting Session…';
  return 'Start Support Session';
}
